var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E169C",
    stroke: "#3E169C",
    strokeWidth: 0.25,
    d: "M22.5 9.875h-1.125V7.5A6.377 6.377 0 0 0 15 1.125 6.377 6.377 0 0 0 8.625 7.5v2.375H7.5A2.63 2.63 0 0 0 4.875 12.5V25A2.63 2.63 0 0 0 7.5 27.625h15A2.63 2.63 0 0 0 25.125 25V12.5A2.63 2.63 0 0 0 22.5 9.875ZM11.375 7.5A3.62 3.62 0 0 1 15 3.875 3.62 3.62 0 0 1 18.625 7.5v2.375h-7.25zm-3.75 17.375v-12.25h14.75v12.25z"
  })));
};
export default SvgLock;